<div class="field-dialog dialog-create-maintenance">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center">
      <h2 class="field-dialog__header__title">
        {{ 'MAINTENANCES.ADD' | translate }}
      </h2>
    </div>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-tab-group class="field-dialog__content">
    <mat-tab [label]="'MAINTENANCES.GENERAL' | translate">
      <tab-general
        [maintenanceForm]="maintenanceForm"
        [problems]="problems"
        [selectedSegment]="selectedSegment"
        [validation]="validation"
      ></tab-general>
    </mat-tab>

    <mat-tab [disabled]="!maintenanceForm.get('location').value || !maintenanceForm.get('segment').value">
      <ng-template mat-tab-label>
        <div class="dialog-create-maintenance__tab-label">
          <span>{{ 'MAINTENANCES.CREATE_DIALOG.TAB_LINKS.LABEL' | translate }}</span>
          <span class="dialog-create-maintenance__tab-label_new-circle"></span>
        </div>
      </ng-template>

      <tab-links [maintenanceForm]="maintenanceForm"></tab-links>
    </mat-tab>

    <mat-tab
      [disabled]="!maintenanceForm.get('maintenanceType')?.value?.id || !maintenanceForm.get('company')?.value?.id"
      [label]="'MAINTENANCES.TABS.WARRANTIES.TITLE' | translate"
    >
      <ng-template matTabContent>
        <div class="field-dialog__content__scroll tab-links">
          <warranties-maintenance-tab
            [hasCreateWarrantyPermission]="hasCreateWarrantyPermission"
            [hasEditWarrantyPermission]="hasEditWarrantyPermission"
            [equipments]="maintenanceForm.get('equipments').value"
            [maintenanceTypeId]="maintenanceForm.get('maintenanceType')?.value?.id"
            [companyId]="maintenanceForm.get('company')?.value?.id"
            [firstView]="firstView"
          ></warranties-maintenance-tab>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <div class="field-dialog__footer" fxLayout="row" fxLayoutAlign="space-between center">
    <button
      class="field-background"
      mat-raised-button
      [disabled]="isLoading || maintenanceForm.invalid"
      (click)="saveMaintenance()"
    >
      {{ 'MAINTENANCES.SAVE' | translate }}
    </button>
  </div>
</div>
